export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/kg.8f22c4fb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};